import { graphql } from '@apollo/client/react/hoc';
import { Loading } from '@spoiler-alert/ui-library';
import PropTypes from 'prop-types';
import React from 'react';
import injectSheet from 'react-jss';
import { UserQuery } from './graphql/queries';
import Routes from './router';
import Tracking from './utilities/tracking-apis';

const styles = {
  site__wrapper: {
    display: 'flex',
    height: '100%',
    width: '100%',
  },
};

class SiteContext extends React.Component {
  state = {
    user: undefined,
  };

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.data.currentUserQuery) {
      if (!localStorage.getItem('loggedIn')) {
        localStorage.setItem('loggedIn', true);
      }
      return { user: nextProps.data.currentUserQuery };
    }
    return null;
  }

  componentDidUpdate() {
    if (this.state.user) {
      const { user } = this.state;
      Tracking.Identify({ ...user, userType: 'Seller' });
    }
  }

  get loading() {
    return (localStorage.getItem('loggedIn') || localStorage.getItem('token')) && !this.state.user;
  }

  get children() {
    const { user } = this.state;
    return <Routes user={user} />;
  }

  render() {
    return (
      <Loading loading={this.loading}>
        <div className={this.props.classes.site__wrapper}>{!this.loading && this.children}</div>
      </Loading>
    );
  }
}

SiteContext.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
};

export default graphql(UserQuery)(injectSheet(styles)(SiteContext));
